// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10.0_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-redpack-rain-default__rolling-board{width:100%;height:100%}.plv-redpack-rain-default__rolling-board__container{width:100%;height:100%}.plv-redpack-rain-default__rolling-board-item{background-repeat:no-repeat;background-position:center;background-size:contain}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
